module.exports = __webpack_public_path__ + "img/daily.26b49ace.png";